import "./CardContainer.css";

import { CssClassNameBuilder } from "../../../utils/CssClassNameBuilder";
import { useMemo } from "react";

interface ICardContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function CardContainer(props: ICardContainerProps) {
  const popupContainerCss = useMemo(() => {
    return CssClassNameBuilder.new()
      .add("card-container")
      .addConditional(props.className, props.className)
      .build();
  }, [props.className]);

  return <div className={popupContainerCss}>{props.children}</div>;
}
